import * as config from "./config.js";

export const UPLOAD_URL = config.API_URL + 'media/upload';
export const MENU_URL = config.API_URL + 'media';
